import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';

import styled from 'styled-components';
import _ from 'lodash';

// Utils
import { createSlugFromTitle } from '../utils';

// Styles
import { backgroundTheme } from '../styles/style-utils';

const LinkWrapper = styled.div`

  padding: 2rem 0 2rem 3rem;
  position: relative;

  &::after {
    content: '';
    text-align: center;
    font-size: 4.2rem;
    font-family: 'Catamaran', sans-serif;
    font-style: normal;
    font-weight: 100;
    position: absolute;
    left: 3rem;
    top: 50%;
    margin-top: -17px;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background: ${props => backgroundTheme(props.themeColors)};
  }

  > a {
    padding: 2rem 2rem 2rem 4.5rem;
  }
`;

const HeaderSection = styled.section`
  padding: 2rem 1rem;
  margin: 5rem 0 4rem 0;
  position: relative;
`;

const BackLinkWrap = styled.div`
  position: absolute;
  display: block;
  width: 100px;
  font-size: 2rem;
  line-height: 2rem;
  padding: 1rem;
  top: -5rem;
  left: 0;
  border-bottom: 1px solid black;

  > a {
    color: black;
  }
`;

const AllFoodsPage = ({ data }) => {

  // show only live foods, ordered aplhabetically
  const liveFoods = _.filter(
    _.sortBy(data.allGoogleSheetFoodsRow.edges, ({ node }) => node.title),
    ({ node }) => node.live
  );

  return (
    <section>
      <Helmet>
        <title>All Foods</title>
      </Helmet>
      <HeaderSection>
        <h1>All Foods</h1>
        <p>Here are all of the foods currently on the site.</p>
        <BackLinkWrap>
          <Link to='/'>&larr; Back</Link>
        </BackLinkWrap>
      </HeaderSection>
      <div>
        {liveFoods.map(({ node }) => (
          <LinkWrapper
            key={node.id}
            themeColors={node.themecolor.split('-')}
            textColor={node.textcolor || 'white'}>
            <Link to={`/${createSlugFromTitle(node.title)}/`}>{node.title}</Link>
          </LinkWrapper>
        ))}
      </div>
    </section>
  );
};

export const query = graphql`
  query FoodsQuery {
    allGoogleSheetFoodsRow {
      edges {
        node {
          id
          live
          title
          themecolor
          textcolor
        }
      }
    }
  }
`;

export default AllFoodsPage;



// WEBPACK FOOTER //
// ./src/pages/foods.js